import { render, staticRenderFns } from "./products-search.vue?vue&type=template&id=489b3780&"
import script from "./products-search.vue?vue&type=script&lang=js&"
export * from "./products-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports